import { createElement, ReactNode } from 'react';
import { createGlobalStyle, ThemeProvider } from 'styled-components';
import {
  HEAD_COLOR,
} from './view/constants/color';

const applyGlobalStyles = (): ReactNode => {
  const GlobalStyle = createGlobalStyle`
    * {
      margin: 0;
      box-sizing: border-box;
    }
    html body {
      width: 100%;
      height: 100%;
      line-height: 1;
      font-smoothing: antialiased;
      font-family: "Noto Sans", "Noto Sans Japanese";
    }
    h1, h2, h3, h4, h5, h6 {
      margin: 0;
      color: ${HEAD_COLOR};
    }
    #app {
      width: 100%;
      height: 100%;
    }
    .ant-calendar-my-select {
      display: flex;
      flex-direction: row-reverse;
      justify-content: center;
    }
  `;

  return (
    <ThemeProvider theme={{ fontFamily: 'Noto Sans' }}>
      <GlobalStyle />
    </ThemeProvider>
  );
};

export default applyGlobalStyles;
